import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrench, Gamepad2 } from 'lucide-react';

import { useAuth } from './hooks/useAuth';

import AppHeader from './components/layout/AppHeader';
import GamesView from './views/GamesView';

import { TermsModal } from './components/TermsModal';
import { PrivacyModal } from './components/PrivacyModal';
import { ContactModal } from './components/ContactModal';
import { OperatorModal } from './components/OperatorModal';

export default function HowToonMain() {
  const navigate = useNavigate();
  const { user, isAdmin, isSemiAdmin } = useAuth();

  const [tab, setTab] = useState('tools');
  const [showFooterTerms, setShowFooterTerms] = useState(false);
  const [showFooterPrivacy, setShowFooterPrivacy] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showOperatorModal, setShowOperatorModal] = useState(false);

  const ctx = {
    user, isAdmin, isSemiAdmin,
    tab, setTab,
    navigate,
  };

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #fdf6ec 0%, #fde8d8 50%, #fce7f3 100%)', fontFamily: "'Inter', sans-serif", paddingBottom: 64 }}>

      <AppHeader ctx={ctx} />

      {tab === 'tools'    && <GamesView ctx={ctx} category="tools" />}
      {tab === 'games'    && <GamesView ctx={ctx} category="games" />}
      {tab === 'archived' && isAdmin && <GamesView ctx={ctx} category="archived" />}

      <footer style={{ marginTop: 48, padding: '20px 16px', borderTop: '1px solid #f3f4f6', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 16px', justifyItems: 'center' }}>
          <button onClick={() => setShowFooterTerms(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: '#6b7280', textDecoration: 'underline', padding: 0 }}>利用規約</button>
          <a href="/privacy-policy" style={{ fontSize: 12, color: '#6b7280', textDecoration: 'underline', padding: 0 }}>プライバシーポリシー</a>
          <button onClick={() => setShowContactModal(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: '#6b7280', textDecoration: 'underline', padding: 0 }}>お問い合わせ</button>
          <a href="/about" style={{ fontSize: 12, color: '#6b7280', textDecoration: 'underline', padding: 0 }}>運営者情報</a>
        </div>
        <p style={{ fontSize: 11, color: '#9ca3af', margin: 0 }}>© 2026 HowToon. All rights reserved.</p>
      </footer>

      <nav className="bottom-nav">
        <button className="bottom-nav-btn" onClick={() => setTab('tools')} style={{ color: tab === 'tools' ? '#9333ea' : '#6b7280' }}>
          <Wrench size={20} /><span>ツール</span>
        </button>
        <button className="bottom-nav-btn" onClick={() => setTab('games')} style={{ color: tab === 'games' ? '#9333ea' : '#6b7280' }}>
          <Gamepad2 size={20} /><span>ゲーム</span>
        </button>
        {isAdmin && (
          <button className="bottom-nav-btn" onClick={() => setTab('archived')} style={{ color: tab === 'archived' ? '#9333ea' : '#6b7280' }}>
            <span style={{ fontSize: 20 }}>🗑️</span><span>没</span>
          </button>
        )}
      </nav>

      {showFooterTerms    && <TermsModal    onClose={() => setShowFooterTerms(false)} />}
      {showFooterPrivacy  && <PrivacyModal  onClose={() => setShowFooterPrivacy(false)} />}
      {showContactModal   && <ContactModal  onClose={() => setShowContactModal(false)} />}
      {showOperatorModal  && <OperatorModal onClose={() => setShowOperatorModal(false)} />}

    </div>
  );
}
